export default {
    name: 'notice',
    props: {
        title: {
            default: ''
        }
    },
    components: {},
    data() {
        return {
            isFixed: false,
            offsetTop: 0,
            heightHeader: 0,
            heightFooter: 0,
            position: {
                left: 0,
                top: 0,
                bottom: 30
            }
        };
    },
    mounted() {
        if (window.innerWidth > 980 && this.$route.name !== 'courses-lesson-detail') {
            this.init()
            window.addEventListener('scroll', this.handleScroll)
            window.addEventListener('resize', this.setPositionSidebar)
        }
    },
    methods: {
        init() {
            if (!document) return;
            this.offsetTop = this.trackingPositonElem(document.querySelector('.education-sidebar'))
            this.heightHeader = document.querySelector('.header-wrap')?.clientHeight || 52;
            this.heightFooter = document.querySelector('.footer')?.clientHeight || 68;

            this.setPositionSidebar()
        },
        setPositionSidebar() {
            this.position.left =
                document.querySelector('.education-sidebar').offsetLeft +
                document.querySelector('.education-wrap').offsetLeft + 15
            this.position.top = this.heightHeader
        },
        handleScroll() {
            const h = document.documentElement,
                st = 'scrollTop'
            const scrolled = (h[st]);
            this.isFixed = (scrolled + this.heightHeader) > this.offsetTop

            const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight - this.heightFooter;
            if (bottomOfWindow) {
                if (document.querySelector('.video-providers') && document.querySelector('.video-providers').classList.contains('fixed')) {
                    this.position.bottom = Math.abs(((document.documentElement.offsetHeight) - (document.documentElement.scrollTop + window.innerHeight)) - this.heightFooter) + 30 + 220
                } else {
                    this.position.bottom = Math.abs(((document.documentElement.offsetHeight) - (document.documentElement.scrollTop + window.innerHeight)) - this.heightFooter) + 30
                }
            } else {
                if (document.querySelector('.video-providers') && document.querySelector('.video-providers').classList.contains('fixed')) {
                    this.position.bottom = 250
                } else this.position.bottom = 30
            }
        },
        trackingPositonElem(element) {
            let body = document.body,
                win = document.defaultView,
                docElem = document.documentElement,
                box = document.createElement('div');
            box.style.paddingLeft = box.style.width = '1px';
            body.appendChild(box);
            let isBoxModel = box.offsetWidth === 2;
            body.removeChild(box);
            box = element.getBoundingClientRect();
            let clientTop = docElem.clientTop || body.clientTop || 0,
                scrollTop = win.pageYOffset || isBoxModel && docElem.scrollTop || body.scrollTop;
            return box.top + scrollTop - clientTop;
        },
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
        window.removeEventListener('resize', this.setPositionSidebar)
    }
}
